import { api } from "../../services";

const reports_opportunities = {
  // namespaced: true,
  state: {
   filter_active: false,
   fields_search: {
      channel_id: null,
      department_id: null,
      user_id: null,
      status: null,
      start_date: null,
      end_date: null,
   },
   chart_values: {},
   model_chart_values: {},
   departments_available: [],
   users_available: []
  },
  getters: {
    
  },
  mutations: {
   //  SET_LEAD_QUOTES(state, payload) {
   //    state.pagination = payload;
   //  },
  },
  actions: {

  }
};

export default reports_opportunities;
